import React, {Component} from 'react';
import {connect} from 'react-redux';
import ApiActions from 'go/actions/api';
import {Menu, Segment} from 'semantic-ui-react';
import TopLevel from './TopLevel';
import _ from 'lodash';
import {API_CLOSEOUT_GET_SUCCESS} from 'common/types';
import {SideNavInternal} from 'go/components/dynamic/layout/SideNavInternal';
import {isFemaUser} from 'common/utils';

const defaultActive = 'CloseoutReport';
const closeoutReport = {
  itemName: 'closeoutReport',
  label: 'Closeout Report',
};

export class CloseoutNavItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checking: true,
      shouldLoad: false,
      hasBeenExpanded: false,
      activeSubPage: defaultActive,
      config: null,
      subItems: [closeoutReport],
    };
  }

  componentDidMount() {
    let {token, grantId, hasFemaPermissions} = this.props;
    if (hasFemaPermissions) {
      this.props
        .getCloseout(token, grantId)
        .then((res) => {
          if (res.type === API_CLOSEOUT_GET_SUCCESS) {
            // we have the config for the closeout report from this res along the data... but can't be sure
            // that other nav items will get their own configs, so rely on the landing page to provide
            this.setState({
              shouldLoad: true,
            });
          }
          this.setState({
            checking: false,
          });
        })
        .catch((err) => {
          console.log(`Closeout could not be retrieved for grantId: ${grantId}.`);
          this.setState({
            checking: false,
          });
        });
    } else {
      this.setState({
        checking: false,
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isActive !== this.props.isActive) {
      // TODO in later story, check for tasks and Closeout letter, then load them
      this.setState({
        hasBeenExpanded: true,
      });
    }
  }

  setActivePage(configName) {
    this.props.loadPageWithConfig(configName).then((config) => {
      this.setState({
        activeSubPage: configName,
        config: config,
      });
    });
  }

  render() {
    const {baseClass, isActive} = this.props;
    const CloseoutReportName = 'Closeout';
    if (this.state.checking) {
      return (
        <Segment tertiary inverted>
          Checking for Closeout...
        </Segment>
      );
    } else if (this.state.shouldLoad) {
      return (
        <React.Fragment>
          <TopLevel
            name={CloseoutReportName}
            baseClass={baseClass}
            handleClick={() => this.setActivePage('closeoutReport')}
            active={isActive}
            isExpandable
          />
          {isActive &&
            _.map(this.state.subItems, (subItem, index) => {
              let subItemActive =
                isActive && this.state.activeSubPage === subItem.itemName;
              return (
                <React.Fragment key={index}>
                  <Menu.Item
                    name={subItem.label}
                    onClick={() => this.setActivePage(subItem.itemName)}
                    as="a"
                    active={subItemActive}
                    href={'#' + CloseoutReportName}
                    className={baseClass + ' indent_1'}
                  >
                    {subItem.label}
                  </Menu.Item>
                  {_.get(this.state, 'config.configType') === subItem.itemName && (
                    <SideNavInternal
                      navToSpecificLocation={() => {
                        /* this is the key to making the sidenav active state work
                            don't use until figuring out how to incorporate VisibilitySensor into this
                          */
                      }}
                      location={this.props.location}
                      title={subItem.itemName + 'Navigation'}
                      startingIndentLevel={2}
                      {...this.state.config.payload}
                    />
                  )}
                </React.Fragment>
              );
            })}
        </React.Fragment>
      );
    } else {
      return <React.Fragment />;
    }
  }
}

export const mapDispatchToProps = (dispatch) => ({
  getCloseout: (token, id) => {
    const action = ApiActions.closeout.getCloseout(token, id);
    const res = dispatch(action);
    return res;
  },
});

export const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    hasFemaPermissions: isFemaUser(state.auth.permissions),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CloseoutNavItem);
